import React from 'react';
import { trpc } from '../../../../api/trpc';

import useSWR from 'swr';
import Pagination from 'rsuite/Pagination';
import classNames from 'classnames';
import tableStyle from '../../parcels/parcels-table.module.css';
import { usePaginationQs } from '../../../../utils/usePagination';
import MyLoader from '../../../common/loader.component';
import moment from 'moment';

export const PromotionBurnBonusesLogsTab = () => {
  const [expandedStates, setExpandedStates] = React.useState<
    Record<number, boolean>
  >({});

  const { take, skip, page, handleSetPage, handleChangeLimit } =
    usePaginationQs(15);
  const { data, isLoading } = useSWR(['promotionBurnBonuses.get'], () =>
    trpc.promotionBurnBonuses.get.query({ take: take, skip: skip }),
  );

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  const total = data?.total || 0;
  const items = data!.data;

  if (!total) {
    return (
      <>
        <div className="pb-4">Данных нет</div>
      </>
    );
  }

  const toggleExpand = (index: number) => {
    setExpandedStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      <div className="pb-4">
        {items.map((log, idx) => {
          const isExpanded = expandedStates[idx] || false;
          const clientIdsString = log.clientIds.join(', ');

          return (
            <div
              key={idx}
              className={classNames(
                'position-relative row g-0',
                tableStyle.tableRow,
              )}
            >
              <div className="col">
                {moment(log.createdAt).format('DD-MM-YYYY')}
              </div>
              <div className="col">{log.comment}</div>
              <div className="col-5 d-flex align-items-start">
                <div
                  className={classNames('flex-grow-1', {
                    'text-truncate': !isExpanded,
                    'text-wrap': isExpanded,
                  })}
                  style={{
                    whiteSpace: isExpanded ? 'normal' : 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  ID клиентов: {clientIdsString}
                </div>
                <div
                  className={'ms-2 cursor-pointer color-gray-450 flex-shrink-0'}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpand(idx);
                  }}
                >
                  {isExpanded ? (
                    <i className={`bi bi-chevron-up`} />
                  ) : (
                    <i className={`bi bi-chevron-down`} />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {total > take && (
        <div className="pb-4">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={['pager']}
            total={total}
            limitOptions={[15, 20]}
            limit={take}
            activePage={page}
            onChangePage={handleSetPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </>
  );
};
